import { PageIntro } from "../components/portfolio/PageIntro";
import { Seo } from "../components/portfolio/Seo";
import { InteriorDesign } from "../components/portfolio/InteriorDesign";
import { Flips } from "../components/portfolio/Flips";
import { MiniFooter } from "../components/portfolio/MiniFooter";

export default function InteriorPage() {
  return (
    <div className="pt-20">
      <Seo
        title="Interior Design & Real Estate"
        description="Residential and commercial interior design, plus a multimillion-dollar real estate flip portfolio from a licensed Illinois REALTOR."
      />
      <PageIntro kicker="Interior Design">
        Residential and commercial spaces, planned and elevated, backed by a multimillion-dollar real estate flip portfolio.
      </PageIntro>
      <InteriorDesign />
      <Flips />
      <MiniFooter />
    </div>
  );
}
